import { defineStore } from 'pinia';
import { api } from '@/lib/api';

export const useAuthStore = defineStore('auth', {
  state: () => ({
    user: null,
    initialized: false,
    initializing: false,
  }),

  getters: {
    isAuthenticated: (state) => Boolean(state.user),
    isVerified: (state) => Boolean(state.user?.email_verified_at),
    isActive: (state) => state.user?.status === 'active',
  },

  actions: {
    async csrf() {
      await api.get('/sanctum/csrf-cookie');
    },

    async initialize() {
      if (this.initialized || this.initializing) return;

      this.initializing = true;

      try {
        await this.fetchCurrentUser();
      } catch (error) {
        if (error.response?.status !== 401) throw error;
        this.user = null;
      } finally {
        this.initialized = true;
        this.initializing = false;
      }
    },

    async fetchCurrentUser() {
      const response = await api.get('/api/v1/me');
      this.user = response.data.data;
      return this.user;
    },

    async login(credentials) {
      await this.csrf();
      const response = await api.post('/api/v1/auth/login', credentials);
      this.user = response.data.data;
      this.initialized = true;
      return this.user;
    },

    async register(details) {
      await this.csrf();
      const response = await api.post('/api/v1/auth/register', details);
      this.user = response.data.data;
      this.initialized = true;
      return this.user;
    },

    async logout() {
      try {
        await api.post('/api/v1/auth/logout');
      } finally {
        this.user = null;
        this.initialized = true;
      }
    },

    async requestPasswordReset(email) {
      await this.csrf();
      return api.post('/api/v1/auth/forgot-password', { email });
    },

    async resetPassword(payload) {
      await this.csrf();
      return api.post('/api/v1/auth/reset-password', payload);
    },

    async resendVerification() {
      return api.post('/api/v1/auth/email/verification-notification');
    },
  },
});
